require("!!E:\\Github\\CXA-Assignment\\node_modules\\script-loader\\addScript.js")(require("!!E:\\Github\\CXA-Assignment\\node_modules\\raw-loader\\index.js!E:\\Github\\CXA-Assignment\\node_modules\\chart.js\\dist\\Chart.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.min.js
// module id = 365
// module chunks = 4